export default (ajaxURL) => {

   $.ajaxSetup({
      url: ajaxURL,
      dataType: 'json',
      type: 'POST',
      cache: false,
      timeout: 120000,
      async: true,
      error: function (qXHR, textStatus, errorThrown) {
         log.error({msg: 'ajax ' + textStatus, qXHR: qXHR, errorThrown: errorThrown});
      },
   });

   $.fn.extend({
      showError: function (type) {
         var row = $(this[0]), ebox = row.find('.error_msg'), act;
         row.removeClass('v error inv req').addClass('error ' + type);
//         console.log('showError', type, row);
         if (row.is(':hidden')) return;
         if (!ebox.length) {
            ebox = $("<div class='error_msg'></div>").on('click', function () {
               row.hideError();
            });
            row.prepend(ebox);
         } else {
            act = ebox.hasClass('req') ? 'req' : 'inv';
            if (act == type) return;
            ebox.removeClass(act);
         }

         var msgid = engine.row[row.data('id')][type];
         if (typeof msgid == 'undefined' || !msgid) {
            log.error({msg: ' missing msgid:' + msgid});
            ebox.remove();
            return;
         }
         var m = engine.getData(msgid);
         if (!m.length) {
            ebox.remove();
            return;
         }
         ebox.html(m).addClass(type);
//         ebox.scrollToMe();

         if (!act) {
            $(row.find(".ui-field-contain div[class*=ui-]:not(:hidden)")).first().effect("transfer", {to: ebox}, 500, function () {
               ebox.css('visibility', 'visible');
            });
         }
      },
      hideError: function () {
         var ebox = $(this[0]).removeClass('v error inv req').find('.error_msg');
         ebox.animate({
            left: '-300px',
            opacity: 0
         }, 200, function () {
            ebox.remove();
         });
      },
      showRow: function () {
         var t = $(this);
         if (t.is(':visible')) {
            t.setInputs('enable');
            return;
         }
//         console.log('on', t.prop('id'), t);
         if (engine.settings.doInit) {
            t.setInputs('enable').show();
         } else {
            t.setInputs('enable').addClass('tin').fadeIn(function () {
               $(this).removeClass('tin', 1000, "easeOutBounce").trigger("updatelayout");
            });
            t.setInputs('enable').trigger("updatelayout");
         }
         return t;
      },
      hideRow: function () {
         var t = $(this);
//         console.log('off', t.prop('id'), t);
         if (t.is(':hidden')) return;
//            t.addClass('tout', 1000, "easeInBack").delay(1000).fadeOut(function () {
//               $(this).addClass('hidden').removeClass('tout');
//            });
         t.hide().setInputs('disable').trigger("updatelayout"); //
         return t;
      },
      setInputs: function (op) {
         var row = $(this);
         row.find('select').each(function () {
            var i = $(this);
            if (i.hasClass('ui-flipswitch-input')) i.flipswitch(op);
            else {
               if (typeof i.data('mobile-selectmenu') == 'undefined') i.selectmenu();
               i.selectmenu(op);
            }
         });
         row.find('.ui-input-text input').textinput(op);
         row.find('.ui-checkbox input,input:radio').checkboxradio(op);
         return row;
      },
      rVal: function (val) {
         var row = $(this);
         if (arguments.length != 0) return row.rValSet(val);
         if (typeof row.data() == 'undefined' || typeof engine.row[row.data('id')] == 'undefined') return null;
//            console.log('rVal',row, engine.rowmap[row.data().id], engine.row[row.data('id')].type);
         return engine.getVal(engine.row[row.data('id')].type, row);
      },
      rValSet: function (val) {
         var row = $(this);
         switch (engine.row[row.data('id')].type) {
            case 'select':
               var s = row.find('select');
               s.find('option').prop('selected', false);
               if (typeof val != 'array') val = [val];
               $.each(val, function (i, k) {
                  s.find("option[value='" + k + "']").prop('selected', 'selected');
               });
               s.selectmenu('refresh');
               break;
            case 'date':
               var i = row.find('input');
               if (i.hasClass('dp')) i.val(val).datepicker('setDate', val);
               else i.val(val.replace('/', '-'));
               break;
            default:
               row.find('input,textarea').val(val);
         }
      },
      selSetOp: function (o, kv, sv, kvtext) {
         var vt = [];
         if (sv) {
             $.each(sv, function(i, v) {
                vt.push(v);
             });
         }
         var op = '', t = $(this), c = Object.keys(o).length, s;
         if (kv) {
            s = c >= 1 ? " selected='selected'" : '';
            if (kvtext) op = "<option data-placeholder='true' value='-'" + s + ">" + kvtext + "</option>";
            else op = "<option data-placeholder='true' value='-'" + s + ">Kérjük válasszon!</option>";
         }
         var temp = [];
         $.each(o, function(key, value) {
            if (key != -1)temp.push({v: value, k: key});
         });
         
         temp.sort(function(a,b){
            if(a.v > b.v){ return 1}
            if(a.v < b.v){ return -1}
            return 0;
         });
         
         if (typeof o[-1] != 'undefined') {
             temp.push({v: o[-1], k: -1}); 
         }
         $.each(temp, function (k, n) {
            if(vt) {
               s = ($.inArray(n.k, vt) !== -1) ? " selected='selected'" : '';
            }
            else {
               s = c == 1 ? " selected='selected'" : '';
            }
            op += "<option value='" + n.k + "'" + s + ">" + n.v + "</option>";
         });
         t.html(op);
         return t;
      },
      // nem fog kelleni
      simplErrShow: function () {
         var t = $(this);
         t.parent().parent().find('.error_msg').css('visibility', 'visible2020');
         return t;
      },
      // nem fog kelleni
      simplErrHide: function () {
         var t = $(this);
         t.parent().parent().find('.error_msg').css('visibility', 'hidden');
         return t;
      },
      /**
       * arg.va: row value. ha nem isset, lekérdezi
       * va.async: ajax async
       *
       * ha van cb, az fut, ha nincs a retben kell lennie
       * @param {type} fn
       * @param {type} object
       * @param {type} callback
       * @returns row
       */
      cmd: function (cmd, arg, cb) {
         arg = arg || {};
         var row = $(this);
         var as = ('async' in arg) ? arg.async : false;
         delete arg.async;
         if (!('va' in arg)) arg.va = row.rVal();
         var wait = ('wait_icon' in arg) ? arg.wait_icon : false;
         if (wait) {
             console.log('wait_icon show', wait);
             $('div.ui-loader').show();
         }
         var request = false;
         $.ajax({
            async: as,
            data: {s: engine.settings.s, op: 'row', id: engine.row[row.data('id')].fid, cmd: cmd, a: arg},
            complete: function (d) {
               request = true;
            },
            success: function (d) {
               if (typeof d == 'undefined' || d == null) return;
               var fn = (typeof d.callback != 'undefined') ? d.callback : cb;
               if (typeof fn == 'undefined') return;
               new engine.func({
                  fn: fn,
                  msg: 'cmd'
               }).call(row, d);
            }
         });
         if (request) {
             if (wait) {
                 console.log('wait_icon hide', wait);
                 $('div.ui-loader').hide();
             }
         }
         return row;
      },

      scrollToMe: function () {
         var x = jQuery(this).offset().top - 100;
         jQuery('html,body').animate({scrollTop: x}, 500);
      }
   });

   $.widget('mobile.selectmenu', $.mobile.selectmenu, {
      _handleListItemClick: function (event) {
         var listItem = $(event.target).closest("li"),
            // Index of option tag to be selected
            oldIndex = this.select[ 0 ].selectedIndex,
            newIndex = $.mobile.getAttribute(listItem, "option-index"),
            option = this._selectOptions().eq(newIndex)[ 0 ];
         // Toggle selected status on the tag for multi selects
         option.selected = this.isMultiple ? !option.selected : true;
         // Toggle checkbox class for multiple selects
         if (this.isMultiple) {
            listItem.find("a")
               .toggleClass("ui-checkbox-on", option.selected)
               .toggleClass("ui-checkbox-off", !option.selected);
         }
         if (!this.isMultiple && oldIndex !== newIndex) {
            this._triggerChange = true;
         }
         if (this.isMultiple) {
            this.select.trigger("change");
//			this.list.find( "li:not(.ui-li-divider)" ).eq( newIndex ).find( "a" ).first().focus();
            this.list.find("li[data-option-index=" + newIndex + "]").find("a").first().focus();
         } else {
            this.close();
         }
         event.preventDefault();
      },
      refresh: function (force) {
         var self, indices;
         if (this.options.nativeMenu) {
            return this._super(force);
         }

         self = this;
         if (force || this._isRebuildRequired()) {
            self._buildList();
         }

         indices = this.selectedIndices();
         self.setButtonText();
         self.setButtonCount();
         self.list.find("li:not(.ui-li-divider)")
            .find("a").removeClass($.mobile.activeBtnClass).end()
            .attr("aria-selected", false)
            .each(function (i) {
               var item = $(this);
               // itttttttttt
               i = parseInt(item[0].getAttribute('data-option-index'));
               if ($.inArray(i, indices) > -1) {
                  item.attr("aria-selected", true);
                  // Multiple selects: add the "on" checkbox state to the icon
                  if (self.isMultiple) {
                     item.find("a").removeClass("ui-checkbox-off").addClass("ui-checkbox-on");
                  } else {
                     if (item.hasClass("ui-screen-hidden")) {
                        item.next().find("a").addClass($.mobile.activeBtnClass);
                     } else {
                        item.find("a").addClass($.mobile.activeBtnClass);
                     }
                  }
               } else if (self.isMultiple) {
                  item.find("a").removeClass("ui-checkbox-on").addClass("ui-checkbox-off");
               }
            });
      }
   });
}